import { useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { GoChevronDown } from "react-icons/go";
import { Loader } from "rsuite";

import { useConfig } from "../../../context/config-context";
import { useModal } from "../../../context/modal-context";
import ModalUpdatePrescriber from "../Modal/update";
import columns from "./columns";
import conditionalRowStyles from "./conditionalRowStyles";
import customStyles from "./customStyles";

export default function TablePrescriber({
  className,
  tutoMode,
  prescribers,
  isLoading,
  limit,
  handleUpdatePrescriber,
  handleLimit,
  handleSort,
  handlePage,
  handleSync,
  isLoadingSync,
  isMenuOpen,
}) {
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const { showModal, setModalLabel } = useModal();
  const siteConfig = useConfig();

  const onClickButtonPrescriberUpdate = async (prescriber) => {
    setModalLabel("Modifier un prescripteur");
    showModal(
      <ModalUpdatePrescriber
        prescriber={prescriber}
        isLoading={isUpdateLoading}
        setIsLoading={setIsUpdateLoading}
        onClick={handleUpdatePrescriber}
      />
    );
  };

  createTheme(
    siteConfig.themes.table.name,
    siteConfig.themes.table.customTheme
  );

  return (
    <div className={`w-full h-full rounded-lg ${className}`}>
      <DataTable
        columns={columns(
          onClickButtonPrescriberUpdate,
          handleSync,
          isLoadingSync
        )}
        className={`rounded-b-xl ${tutoMode ? "!pointer-events-none" : ""}`}
        data={prescribers.docs}
        noDataComponent={
          <span className="w-full font-semibold text-center">
            {siteConfig.no_data}
          </span>
        }
        customStyles={customStyles(tutoMode, isMenuOpen)}
        conditionalRowStyles={conditionalRowStyles}
        defaultSortFieldId={2}
        defaultSortAsc={true}
        sortIcon={<GoChevronDown className="ml-1" color="var(--light)" />}
        striped
        highlightOnHover
        pagination
        theme="solarized"
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[25, 50, 100]}
        progressPending={isLoading}
        progressComponent={<Loader className="w-full text-center" />}
        paginationServer
        paginationDefaultPage={prescribers.page}
        paginationServerOptions={{
          persistSelectedOnPageChange: true,
          persistSelectedOnSort: true,
        }}
        paginationTotalRows={prescribers.totalDocs}
        onChangePage={async (page) => await handlePage(page)}
        onChangeRowsPerPage={async (newPerPage) =>
          await handleLimit(newPerPage)
        }
        sortServer
        onSort={async (column, sortDirection) =>
          await handleSort(
            `{"${column.sortfield}":${sortDirection === "desc" ? -1 : 1}${
              column.sortfield === "lastName"
                ? `,"firstName":${sortDirection === "desc" ? -1 : 1}`
                : ""
            }}`
          )
        }
        dense
        paginationComponentOptions={{
          rowsPerPageText:
            siteConfig.components.table_prescriber.pagination.rowsPerPageText,
          rangeSeparatorText:
            siteConfig.components.table_prescriber.pagination
              .rangeSeparatorText,
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: "All",
        }}
      />
    </div>
  );
}
